import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { FingerprintAccessComponent } from './modals/fingerprint-access/fingerprint-access.component';
import { HeaderComponent } from './header/header.component';
import { SearcherComponent } from './searcher/searcher.component';
import { FooterComponent } from './footer/footer.component';
import { ConnectAlarmComponent } from './modals/connect-alarm/connect-alarm.component';
import { DefaultModalComponent } from './modals/default-modal/default-modal.component';
import { MaintenanceComponent } from './modals/menu/maintenance/maintenance.component';
import { ReportFailureComponent } from './modals/report-failure/report-failure.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginProblemsComponent } from './modals/login-problems/login-problems.component';
import { TranslateModule } from '@ngx-translate/core';
import { WordOfDuressComponent } from './modals/menu/protocol/word-of-duress/word-of-duress.component';
import { ProtocolComponent } from './modals/menu/protocol/protocol.component';
import { MoreComponent } from './modals/menu/more/more.component';
import { HistoricalComponent } from './modals/menu/historical/historical.component';
import { PhotosCamerasComponent } from './modals/photos-cameras/photos-cameras.component';
import { ChatComponent } from './modals/chat/chat.component';
import { IncidenceDetailComponent } from './modals/incidence-detail/incidence-detail.component';
import { NewUserComponent } from './modals/new-user/new-user.component';
import { BillsComponent } from './modals/menu/more/bills/bills.component';
import { BillingDataComponent } from './modals/billing-data/billing-data.component';
import { TermsOfUseComponent } from './modals/menu/more/terms-of-use/terms-of-use.component';
import { UserManualsComponent } from './modals/menu/more/user-manuals/user-manuals.component';
import { SettingsComponent } from './modals/menu/more/settings/settings.component';
import { SupportComponent } from './modals/menu/more/support/support.component';
import { PrivacyPolityComponent } from './modals/menu/more/privacy-polity/privacy-polity.component';
import { CommandComponent } from './modals/settings/command/command.component';
import { KeyComponent } from './modals/settings/key/key.component';
import { CountdownComponent } from './modals/countdown/countdown.component';
import { CodeComponent } from './modals/settings/code/code.component';
import { PanicCodeComponent } from './modals/settings/panic-code/panic-code.component';
import { ScanQrWebComponent } from './modals/scan-qr-web/scan-qr-web.component';
import { CookiesComponent } from './modals/menu/more/cookies/cookies.component';
import { PtzComponent } from './modals/video-sbn-cloud/ptz/ptz.component';
import { VideoGenericModalComponent } from './modals/video-sbn-cloud/modal/generic-modal/video-generic-modal.component';
import { DeviceDetailComponent } from './modals/device-detail/device-detail.component';
import {AngularFittextModule} from 'angular-fittext';
import { NotificationPushComponent } from './notification-push/notification-push.component';
import { LoadingScreenComponent } from './loading-screen/loading-screen.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { BillDetailComponent } from './modals/menu/more/bills/bill-detail/bill-detail.component';
import { ConfirmComponent } from './modals/confirm/confirm.component';
import { ZoomTutorialComponent } from './modals/video-sbn-cloud/zoom-tutorial/zoom-tutorial.component';
import { InstallationNameComponent } from './installation-name/installation-name.component';
import { PinchZoomModule } from './ivy-pinch/pinch-zoom.module';
import { NewsPresentationComponent } from './modals/news-presentation/news-presentation.component';
import { NpsComponent } from './modals/nps/nps.component';
import { VaelsysComponent } from './modals/video-sbn-cloud/vaelsys/vaelsys.component';
import { VaelsysWebrtcLibModule } from 'libs/vaelsys-webrtc-lib';
import { RecordingsComponent } from './modals/video-sbn-cloud/recordings/recordings.component';
import { HeaderCorporateComponent } from './header-corporate/header-corporate.component';
import { NgxVideoTimelineModule } from 'libs/ngx-video-timeline';
@NgModule({
  declarations: [
    FingerprintAccessComponent,
    HeaderComponent,
    SearcherComponent,
    FooterComponent,
    ConnectAlarmComponent,
    DefaultModalComponent,
    HistoricalComponent,
    MaintenanceComponent,
    ReportFailureComponent,
    LoginProblemsComponent,
    MoreComponent,
    ProtocolComponent,
    WordOfDuressComponent,
    PhotosCamerasComponent,
    ChatComponent,
    IncidenceDetailComponent,
    NewUserComponent,
    BillsComponent,
    BillingDataComponent,
    UserManualsComponent,
    TermsOfUseComponent,
    SettingsComponent,
    SupportComponent,
    PrivacyPolityComponent,
    CommandComponent,
    KeyComponent,
    CountdownComponent,
    CodeComponent,
    PanicCodeComponent,
    ScanQrWebComponent,
    CookiesComponent,
    PtzComponent,
    VideoGenericModalComponent,
    DeviceDetailComponent,
    NotificationPushComponent,
    LoadingScreenComponent,
    BillDetailComponent,
    ConfirmComponent,
    ZoomTutorialComponent,
    InstallationNameComponent,
    NewsPresentationComponent,
    NpsComponent,
    VaelsysComponent,
    RecordingsComponent,
    HeaderCorporateComponent
  ],
  exports: [
    FingerprintAccessComponent,
    HeaderComponent,
    SearcherComponent,
    FooterComponent,
    ConnectAlarmComponent,
    DefaultModalComponent,
    HistoricalComponent,
    MaintenanceComponent,
    ReportFailureComponent,
    LoginProblemsComponent,
    MoreComponent,
    ProtocolComponent,
    WordOfDuressComponent,
    PhotosCamerasComponent,
    ChatComponent,
    IncidenceDetailComponent,
    NewUserComponent,
    BillsComponent,
    BillingDataComponent,
    UserManualsComponent,
    TermsOfUseComponent,
    SettingsComponent,
    SupportComponent,
    PrivacyPolityComponent,
    CommandComponent,
    KeyComponent,
    CountdownComponent,
    CodeComponent,
    PanicCodeComponent,
    ScanQrWebComponent,
    CookiesComponent,
    PtzComponent,
    VideoGenericModalComponent,
    DeviceDetailComponent,
    NotificationPushComponent,
    LoadingScreenComponent,
    BillDetailComponent,
    ConfirmComponent,
    ZoomTutorialComponent,
    InstallationNameComponent,
    NewsPresentationComponent,
    NpsComponent,
    VaelsysComponent,
    RecordingsComponent,
    HeaderCorporateComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    PdfViewerModule,
    PinchZoomModule,
    AngularFittextModule,
    VaelsysWebrtcLibModule,
    NgxVideoTimelineModule
  ]
})
export class ComponentsModule { }
